var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loading
        ? _c("gg-loading", {
            attrs: {
              loading: true,
              type: "card"
            }
          })
        : !_vm.service
        ? _c(
            "gg-card",
            [
              _c("gg-card-text", [
                _c(
                  "div",
                  {
                    staticClass: "py-8 text-center"
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "mb-2 font-weight-medium"
                      },
                      [_vm._v("We couldn't find this email account.")]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "mb-4"
                      },
                      [
                        _vm._v(
                          "It may have been cancelled, or the address is wrong."
                        )
                      ]
                    ),
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          secondary: "",
                          to: "/email"
                        }
                      },
                      [_vm._v("Back to Email")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : !_vm.hostingReady
        ? _c(
            "gg-card",
            [
              _c("gg-card-text", [
                _c(
                  "div",
                  {
                    staticClass: "py-8 text-center"
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "mb-4 font-weight-medium"
                      },
                      [
                        _vm._v(
                          "We couldn't open the hosting service behind this account."
                        )
                      ]
                    ),
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          secondary: ""
                        },
                        on: {
                          click: _vm.load
                        }
                      },
                      [_vm._v("Try again")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : [
            _c(
              "v-row",
              {
                staticClass: "align-center mb-3"
              },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "d-flex align-center flex-wrap",
                    attrs: {
                      cols: "12"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "mr-auto my-1"
                      },
                      [
                        _c("v-breadcrumbs", {
                          staticClass: "pa-0 pb-1 gg-breadcrumbs",
                          attrs: {
                            items: _vm.crumbs
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "divider",
                              fn: function fn() {
                                return [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: ""
                                      }
                                    },
                                    [_vm._v("mdi-chevron-right")]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ])
                        }),
                        _c(
                          "gg-card-title",
                          {
                            staticClass: "pt-0 pb-0 mb-3"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isAddon
                                  ? _vm.mainDomain
                                  : _vm.service.domain
                              )
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "body-2"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text--secondary"
                              },
                              [_vm._v("Email Plan:")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(_vm.account && _vm.account.planLabel) +
                                " "
                            )
                          ]
                        ),
                        _vm.isAddon
                          ? _c(
                              "div",
                              {
                                staticClass: "body-2 mt-1"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text--secondary"
                                  },
                                  [_vm._v("Addon domain of:")]
                                ),
                                _vm._v(" " + _vm._s(_vm.service.domain) + " ")
                              ]
                            )
                          : _vm.addonDomains.length
                          ? _c(
                              "div",
                              {
                                staticClass: "body-2 mt-1"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text--secondary"
                                  },
                                  [_vm._v("Addon domains:")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.addonDomains.join(", ")) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "v-tabs",
              {
                staticClass: "email-account-tabs mb-0",
                attrs: {
                  flat: "",
                  "background-color": "transparent"
                }
              },
              [
                _c("v-tabs-slider", {
                  attrs: {
                    color: "green"
                  }
                }),
                _vm._l(_vm.sections, function(section) {
                  return _c(
                    "v-tab",
                    {
                      key: section.path,
                      staticClass: "text-none",
                      attrs: {
                        to: _vm.sectionPath(section)
                      }
                    },
                    [_vm._v(" " + _vm._s(section.title) + " ")]
                  )
                })
              ],
              2
            ),
            _c("hr", {
              staticClass: "mt-0 mb-4"
            }),
            _c("router-view", {
              attrs: {
                service: _vm.service
              },
              on: {
                "create-mailbox": function createMailbox($event) {
                  _vm.modals.create = true
                }
              }
            }),
            _c("create-mailbox-modal", {
              attrs: {
                "is-active": _vm.modals.create,
                "service-id": _vm.service.id,
                "default-domain": _vm.isAddon ? _vm.mainDomain : ""
              },
              on: {
                close: function close($event) {
                  _vm.modals.create = false
                }
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }